import React, {Component} from 'react';

class Voice extends Component {

    startDictation(){

        console.log("Inside start dictation");

        if (window.hasOwnProperty('webkitSpeechRecognition')) {

            var recognition = new window.webkitSpeechRecognition();
      
            recognition.continuous = false;
            recognition.interimResults = false;
      
            recognition.lang = "en-US";
            recognition.start();
      
            recognition.onresult = function(e) {
              document.getElementById('transcript').value
                                       = e.results[0][0].transcript;
              recognition.stop();
              document.getElementById('labnol').submit();
            };
      
            recognition.onerror = function(e) {
              recognition.stop();
            }
      
          }
      
    }

    render() {
        return (
            <form id="labnol" method="get" action="https://www.google.com/search">
                <div class="speech">
                    <input type="text" name="q" id="transcript" placeholder="Speak" />
                    <img onclick={this.startDictation} src="//i.imgur.com/cHidSVu.gif" />
                </div>
            </form>
        );
    }
}

export default Voice;


// WEBPACK FOOTER //
// ./src/components/voice/voiceHome.js